import { FileInInspectionType, FileType } from 'state';

export const flattenInspectionFiles = (files: FileInInspectionType): FileType[] => {
  if (!files) return [];

  const inspectionFiles: FileType[] = [];

  Object.keys(files).forEach(k => {
    inspectionFiles.push(...files[k]);
  });

  return inspectionFiles;
};
